import VueRouter from 'vue-router';
import Overview from '@/components/Overview';
import Login from '@/pages/Login';
import Regional from '@/pages/Regional';
import MySamples from '@/pages/MySamples';
import UserSamplesListing from '@/pages/UserSamplesListing';
import ViewSample from '@/pages/ViewSample';
// import ManageData from '@/pages/ManageData';
import EditSample from '@/pages/EditSample';
import WinemakingNotes from '@/pages/WinemakingNotes';
import Users from '@/pages/Users';


const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/overview',
    },
    {
      path: '/overview',
      name: 'Overview',
      component: Overview,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/regional',
      name: 'Regional',
      component: Regional,
    },
    {
      path: '/samples',
      name: 'MySamples',
      component: MySamples,
    },
    {
      path: '/samples-user/:user_id',
      name: 'MySamples',
      component: UserSamplesListing,
      props: true,
    },
    {
      path: '/samples/:id',
      name: 'ViewSample',
      component: ViewSample,
      props: true,
    },
    // {
    //   path: '/manage-data',
    //   name: 'ManageData',
    //   component: ManageData,
    // },
    {
      path: '/sample/edit/:date/:loc_id/:var_id',
      name: 'EditSample',
      component: EditSample,
      props: true,
    },
    {
      path: '/sample/edit/:user_id',
      name: 'EditSample',
      component: EditSample,
      props: true,
    },
    {
      path: '/winemaking/:var_id?',
      name: 'WinemakingNotes',
      component: WinemakingNotes,
      props: true,
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
    },
  ],
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js